module.exports = __webpack_public_path__ + "static/media/matilde-special-adventour-bored.7923872d.png";